module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        tabConfigNavKey: 'customers',
    },

    methods: {
        sanitizeTabOptionsByAttributes(tabOptions, entityAttributes, entityID){
            const titleParts = []
            if(entityAttributes.title)          titleParts.push(entityAttributes.title);
            if(entityAttributes.firstname)      titleParts.push(entityAttributes.firstname);
            if(entityAttributes.lastname)       titleParts.push(entityAttributes.lastname);
            if(entityAttributes.capacity)       titleParts.push(`(${entityAttributes.capacity})`);
            tabOptions.title = titleParts.join(' ')
            tabOptions.titleSuffix = ` [${entityID}]`

            return tabOptions
        },
    },
}